import { NgModule } from '@angular/core';
import { WarningTooltipComponent } from './warning-tooltip.component';

export const WarningTooltipModuleExports = [WarningTooltipComponent];

@NgModule({
    imports: [],
    declarations: [...WarningTooltipModuleExports],
    exports: [...WarningTooltipModuleExports],
    providers: []
})
export class WarningTooltipModule {}
